/*
 * @Author: your name
 * @Date: 2020-11-03 16:07:47
 * @LastEditTime: 2020-12-03 09:15:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \znjz-vue\src\utils\request.js
 */

import axios from "axios";
import router from "../router/index";
import { loginIn, loginOut } from "@/utils/loginIn.js";
// 添加请求拦截器
axios.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    const token = window.localStorage.getItem("token");
    config.headers["Content-Type"] = "application/json";
    if (token) {
      config.headers["Token"] = token;
    } else {
      config.headers["Token"] = "";
    }
    return config;
  },
  error => {
    // 对请求错误做些什么
    // console.log('传参错误')
    return Promise.reject(error);
  }
);

// 请求后处理的逻辑
axios.interceptors.response.use(
  response => {
    //对响应数据做点什么
    if (response.data.code == 1001) {
      // router.replace({
      //   path: "/login",
      //   query: { redirect: router.currentRoute.fullPath } //登录成功后跳入浏览的当前页面
      // });
      loginOut()
    }
    return response;
  },
  error => {
    // 对响应错误做点什么
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 这里写清除token的代码
          // router.replace({
          //     path: '/login',
          //     query: {redirect: router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
          // })
          loginIn();
      }
    }
    return Promise.reject(error);
  }
);

export default axios;



// WEBPACK FOOTER //
// ./src/utils/request.js